// Dependencies
import {
  TIPOS_ACT_COSTE_REQUEST,
  TIPOS_ACT_COSTE_OK,
  TIPOS_ACT_COSTE_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TIPOS_ACT_COSTE_REQUEST:
      return { ...state, loading: true };
    case TIPOS_ACT_COSTE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case TIPOS_ACT_COSTE_OK:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
